import React, { Component } from 'react';

// Node
import { toast } from 'react-toastify';

//utils
import { onlyNumbers } from '../../utils';

// styles
import { ContainerMultiply } from './style';
import { InputMult, ButtonMult } from '../../styles/forms';

let timeoutId = null;

class MultiplyCart extends Component {
  constructor(props) {
    super(props);

    this.InputValue = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.value !== this.props.value &&
      this.InputValue &&
      parseInt(this.InputValue.value) !== parseInt(this.props.value)
    ) {
      this.InputValue.value = this.props.value;
    }
  }

  update = value => {
    const { handleMultiplyItem, referencia } = this.props;

    const timeOut = () => {
      handleMultiplyItem(referencia, parseInt(value));
    };

    if (timeoutId) {
      window.clearTimeout(timeoutId);
    }

    timeoutId = window.setTimeout(timeOut, 1200);
  };

  blur = (e, step, val) => {
    const { min, value } = this.props;
    let newValue = val;
    let isStep = false;

    if (step !== 1 && step !== '') {
        isStep = true;
        if (val % step !== 0) {
          const NewStep = step - (val % step);
          newValue = parseInt(val) + NewStep;
        }

    }

    if (parseInt(val) === parseInt(value) && (step === 1 || step === '')) {
      return false;
    }

    if (parseInt(val) < min) {
      isStep = false;
      toast.error(`Quantidade mínima alcançada : ${min}`, {
        toastId: 'multiply_min',
      });

      this.InputValue.value = min;
    }

    this.InputValue.value = (isStep) ? newValue : this.InputValue.value;

    this.update(this.InputValue.value);
  };

  increment = (e, step, value) => {
    let newStep = (step === 1 || step === '') ? 1 : step

    this.InputValue.value = parseInt(value) + newStep;

    this.update(this.InputValue.value);
  };

  decrement = (e, step, value) => {
    const { min } = this.props;
    let newStep = (step === 1 || step === '') ? 1 : step

    if (parseInt(value) <= min) {
      toast.error(`Quantidade mínima alcançada : ${min}`, {
        toastId: 'multiply_min',
      });
      return false;
    }

    this.InputValue.value = parseInt(value) - newStep;

    this.update(this.InputValue.value);
  };

  handle = (e, cb) => {
    const { min, step } = this.props;

    if (this.InputValue.value === '') {
      this.InputValue.value = min;
    }

    let value = this.InputValue.value;

    cb(e, step, value);
  };

  render() {
    const { value, disabled } = this.props;

    return (
      <ContainerMultiply style={{ opacity: disabled ? 0.5 : 1 }}>
        <ButtonMult 
          onClick={(e) => !disabled && this.handle(e, this.decrement)} 
          disabled={disabled}
        >
          -
        </ButtonMult>
        <InputMult
          type="text"
          ref={ref => (this.InputValue = ref)}
          defaultValue={value}
          onBlur={(e) => this.handle(e, this.blur)}
          onChange={e => (this.InputValue.value = onlyNumbers(e.currentTarget.value))}
          disabled={disabled}
        />
        <ButtonMult 
          onClick={(e) => !disabled && this.handle(e, this.increment)} 
          disabled={disabled}
        >
          +
        </ButtonMult>
      </ContainerMultiply>
    );
  }
}

export default MultiplyCart;
